/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-sort': {
    width: 16,
    height: 16,
    viewBox: '-156 -60 632 632',
    data: '<g stroke-width="1" _fill="#000" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g><path pid="0" d="M27.66 224h264.7c24.6 0 36.89-29.78 19.54-47.12L179.6 40.08a27.534 27.534 0 00-19.53-8.107c-7.055 0-14.09 2.701-19.45 8.107L8.119 176.9C-9.229 194.2 3.055 224 27.66 224zm-8.05-36l132.3-136.6c2.19-2.21 4.19-3.4 8.09-3.4 3.09 0 6.006 1.215 8.027 3.232l132.5 136.1c4.932 4.932 3.385 10.48 2.49 12.64C302.2 202.1 299.3 208 292.3 208H27.66c-6.99 0-9.82-5.9-10.72-7.2-.89-2.1-2.44-7.7 2.67-12.8zM292.3 288H27.66c-24.6 0-36.89 29.77-19.54 47.12l132.5 136.8C145.9 477.3 152.1 480 160 480c7.053 0 14.12-2.703 19.53-8.109l132.3-136.8C329.2 317.8 316.9 288 292.3 288zm8.1 35.1L168.3 459.7c-2.3 3.1-5.2 4.3-8.3 4.3-3.059 0-5.926-1.195-7.951-3.24l-132.6-136.1C14.5 318.9 16.05 313.3 16.94 311.2c.9-2.2 3.73-7.2 10.72-7.2h264.7c6.99 0 9.822 5.014 10.71 7.17.03 2.13 2.43 7.73-2.67 11.93z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-sort.js